module.exports = __webpack_public_path__ + "static/media/logo.9753aa0c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/projects/bokus/logo.png
// module id = 56
// module chunks = 0